/**
 * `FileUploadCallDetailsActions` are actions related to the display and logic
 * of showing the details for a call
 */
import alt from 'components/Dispatcher';

class FileUploadCallDetailsActions {
  constructor() {
    this.generateActions(
      'hideCallDetails',
      'hideCallSyncCRM',
      'showCallDetails',
      'showCallSyncCRM',
      'showCRMRecordDialog',
      'hideCRMRecordDialog',
      'showAddToLibraryDialog',
      'hideAddToLibraryDialog',
      'showTranscriptionDialog',
      'hideTranscriptionDialog',
      'blockCallPlaying',
      'unblockCallPlaying',
      'showCallDeleteDialog',
      'hideCallDeleteDialog',
      'flashCallFeedbackActions'
    );
  }
}

export default alt.createActions(FileUploadCallDetailsActions);
